import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import IncomeDetails from "../../../components/DriverMobile/IncomeDetails";
import IncomeOverview from "../../../components/DriverMobile/IncomeOverview";

function MainDriverMobile() {
    const { driverId } = useParams();

    const [incomeOverviewOpen, setIncomeOverviewOpen] = useState(false);
    const [incomeDetailOpen, setIncomeDetailOpen] = useState(false);
    const [lastStart, setLastStart] = useState('');
    const [lastEnd, setLastEnd] = useState('');
    const [lastStartTime, setLastStartTime] = useState(0);
    const [lastEndTime, setLastEndTime] = useState(0);

    function handleIncomeDetailOpen(open) {
        setIncomeDetailOpen(open);
        if(!open) {
            window.localStorage.setItem('income-overview-open', true)
        }
    }
    function handleLastPeriod(lastStart, lastEnd, lastStartTime, lastEndTime) {
        setLastStart(lastStart);
        setLastEnd(lastEnd);
        setLastStartTime(lastStartTime);
        setLastEndTime(lastEndTime);
    }

    useEffect(() => {
        // In direct-entry mode the driver lands directly on this page, so we
        // always show the overview regardless of the localStorage flag.
        if (driverId) {
            setIncomeOverviewOpen(true);
        } else {
            setIncomeOverviewOpen(window.localStorage.getItem('income-overview-open') === 'true');
        }
    }, [driverId, window.localStorage.getItem('income-overview-open')])

    return (
        <div>
            {
                incomeOverviewOpen &&
                <IncomeOverview 
                    handleIncomeDetailOpen={handleIncomeDetailOpen} 
                    open={incomeOverviewOpen}
                    handleLastPeriod={handleLastPeriod}
                />
            }
            {
                incomeDetailOpen &&
                <IncomeDetails 
                    handleIncomeDetailOpen={handleIncomeDetailOpen} 
                    lastStart={lastStart}
                    lastEnd={lastEnd}
                    lastStartTime={lastStartTime}
                    lastEndTime={lastEndTime}
                />
            }
        </div>
    )
}
export default MainDriverMobile;